export const AUTH_ENDPOINTS = {
  LOGIN: "/auth/login",
  REGISTER: "/auth/register",
  LOGOUT: "/auth/logout",
  REFRESH: "/auth/refresh",
  ME: "/users/me",
  REQUEST_FORGOT_PASSWORD: "/emails/forgot-password",
  CONFIRM_OTP: "/auth/confirm-otp",
  CONFIRM_RESET_TOKEN: "/auth/confirm-reset-token",
  UPDATE_PASSWORD: "/auth/update-password",
};
